import { request } from '@/utils/request';
import type { ApiResponse, WrappedResult, WrappedItemsResult } from './types';

const cooperativesApi = {
  getAll(
    params?: cyrian.api.cooperatives.GetParams,
  ): ApiResponse<WrappedItemsResult<cyrian.api.cooperatives.Cooperative[]>> {
    return request({
      method: 'get',
      url: '/cooperatives',
      params,
    });
  },
  get(id: number): ApiResponse<WrappedResult<cyrian.api.cooperatives.Cooperative>> {
    return request({
      method: 'get',
      url: `/cooperatives/${id}`,
    });
  },
  create(
    data: cyrian.api.cooperatives.CooperativeCreateParams,
  ): ApiResponse<WrappedResult<cyrian.api.cooperatives.Cooperative>> {
    return request({
      method: 'post',
      url: '/cooperatives',
      data,
    });
  },
  update(
    id: number,
    data: cyrian.api.cooperatives.CooperativeUpdateParams,
  ): ApiResponse<WrappedResult<cyrian.api.cooperatives.Cooperative>> {
    return request({
      method: 'patch',
      url: `/cooperatives/${id}`,
      data,
    });
  },
  delete(id: number): ApiResponse<WrappedResult<void>> {
    return request({
      method: 'delete',
      url: `/cooperatives/${id}`,
    });
  },
};

export default cooperativesApi;
